import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import { useRole } from "components/Hooks/UserHooks";
import CountUp from "react-countup";
import { getPushLogs } from "store/push-notification/thunk";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownOption from "components/Common/DropdownOption";
import DropdownStatus from "components/Common/DropdownStatus";
import {
  COLOR_NOTIFY_TYPE,
  COLOR_OPEN_STATUS,
  PUSH_LOG_NOTIFY_TYPE,
  PUSH_LOG_OPEN_STATUS,
  LIST_OPTION_OS,
  PUSH_LOG_PUSH_STATUS,
  getPlatFormImage,
  MANUAL_PUSH_REDIRECT_SCREEN_TARGET,
  COLOR_PUSH_LOG_STATUS,
  COLOR_USER_TYPE_LOG,
  USER_TYPE_LOG_OPTION,
  getOptionImage,
  LIST_OPTION_SOURCE_APP,
  AGENCY_APP_NAME_OPTION,
  APP_TYPE_OPTIONS,
  NOTIFICATION_ACTION,
  MANUAL_PUSH_SAVE_OPTION,
  COLOR_MANUAL_PUSH_SAVE_OPTION,
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import CollapseContent from "components/Common/CollapseContent";
import userApi from "api/userApi";
import { truncate } from "utils";
import TooltipCustom from "components/Common/TooltipCustom";
import DropdownOptionImage from "components/Common/DropdownOptionImage";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import CopyWrapper from "components/Common/CopyWrapper";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import IPHONE_MODELS from "helpers/iphone_models";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "createdAt";

registerLocale("en", en);
registerLocale("ko", ko);

const PushLog = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const { userPermissions } = useRole();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    title: withDefault(StringParam, ""),
    body: withDefault(StringParam, ""),
    uuid: withDefault(StringParam, ""),
    email: withDefault(StringParam, ""),
    nickname: withDefault(StringParam, ""),
    app_name: withDefault(StringParam, ""),
    os: withDefault(StringParam, ""),
    notify_action: withDefault(StringParam, ""),
    notify_type: withDefault(StringParam, ""),
    push_status: withDefault(StringParam, ""),
    open_status: withDefault(StringParam, ""),
    user_type: withDefault(StringParam, ""),
    save_option: withDefault(StringParam, ""),
    start_date: withDefault(
      StringParam,
      formatDateStringToUTC(
        moment(new Date()).startOf("day").format("Y-MM-DD HH:mm:ss")
      )
    ),
    end_date: withDefault(
      StringParam,
      formatDateStringToUTC(
        moment(new Date()).endOf("day").format("Y-MM-DD HH:mm:ss")
      )
    ),
  });

  const MANUAL_PUSH_REDIRECT_SCREEN_TARGET_LANG =
    NOTIFICATION_ACTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const LIST_OPTION_NOTIFY_TYPE_LANG =
    PUSH_LOG_NOTIFY_TYPE?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const LIST_OPTION_PUSH_STATUS_LANG =
    PUSH_LOG_PUSH_STATUS?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const LIST_OPTION_OPEN_STATUS_LANG =
    PUSH_LOG_OPEN_STATUS?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [titleSearch, setTitleSearch] = useState<string>(
    query?.title || ""
  );
  const [contentSearch, setContentSearch] = useState<string>(
    query?.body || ""
  );
  const [uuidSearch, setUUIDSearch] = useState<string>(query?.uuid || "");
  const [emailSearch, setEmailSearch] = useState<string>(query?.email || "");
  const [nicknameSearch, setNicknameSearch] = useState<string>(
    query?.nickname || ""
  );

  const [isGuestSearch, setIsGuestSearch] = useState<any>(
    USER_TYPE_LOG_OPTION?.find((item) => item?.value === query?.user_type)
      ?.value ?? ""
  );

  const [appNameSearch, setAppNameSearch] = useState<Option | any>(
      AGENCY_APP_NAME_OPTION?.find((item) => item?.value === query?.app_name)
        ?.value || ""
    );

  const [oSSearch, setOSSearch] = useState<any | null>(
    LIST_OPTION_OS?.filter(
      (item) => String(item?.value) === String(query?.os)
    )[0]?.value || ""
  );
  const [dataTypeSearch, setDataTypeSearch] = useState<Option | null>(
    MANUAL_PUSH_REDIRECT_SCREEN_TARGET_LANG?.filter(
      (item) => String(item?.value) === String(query?.["notify_action"])
    )[0]
  );
  const [notifyTypeSearch, setNotifyTypeSearch] = useState<Option | null>(
    LIST_OPTION_NOTIFY_TYPE_LANG?.filter(
      (item) => String(item?.value) === String(query?.["notify_type"])
    )[0]
  );
  const [pushStatusSearch, setPushStatusSearch] = useState<Option | null>(
    LIST_OPTION_PUSH_STATUS_LANG?.find(
      (item) => String(item?.value) === String(query?.["push_status"])
    ) || null
  );
  const [openStatusSearch, setOpenStatusSearch] = useState<Option | null>(
    LIST_OPTION_OPEN_STATUS_LANG?.filter(
      (item) => item?.value === parseInt(query?.["open_status"])
    )[0]
  );
  const [saveOptionSearch, setSaveOptionSearch] = useState<Option | any>(
    MANUAL_PUSH_SAVE_OPTION?.find((item) => item?.value == query?.save_option)
      ?.value || ""
  );

  const [dateSearch, setDateSearch] = useState<any[]>([
    moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
    moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
  ]);
  const [start_date, end_date] = dateSearch;

  const selectLayoutState = (state: any) => state.PushNotification;
  const PushLogProperties = createSelector(selectLayoutState, (state) => {
    return {
      pushLogs: state.pushLogs,
      isPushLogLoading: state.isPushLogLoading,
      isPushLogSuccess: state.isPushLogSuccess,

      error: state.error,
    };
  });

  // Inside your component
  const { pushLogs, isPushLogLoading } = useSelector(PushLogProperties);

  function loadTableData() {
    dispatch(getPushLogs(query));
  }

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      title: titleSearch || "",
      body: contentSearch || "",
      uuid: uuidSearch || "",
      email: emailSearch || "",
      nickname: nicknameSearch || "",
      os: oSSearch || "",
      app_name: appNameSearch || "",
      notify_action: dataTypeSearch?.value || "",
      notify_type: notifyTypeSearch?.value || "",
      push_status: pushStatusSearch?.value || "",
      open_status: openStatusSearch?.value,
      user_type: isGuestSearch,
      save_option: saveOptionSearch,
      start_date: start_date
        ? formatDateStringToUTC(
            moment(new Date(start_date))
              .startOf("day")
              .format("Y-MM-DD HH:mm:ss")
          )
        : "",
      end_date: end_date
        ? formatDateStringToUTC(
            moment(new Date(end_date)).endOf("day").format("Y-MM-DD HH:mm:ss")
          )
        : "",
      sort_by: TYPE_SELECT_DEFAULT,
      time_request: +new Date(),
      page: 1,
    });
  };

  const resetData = () => {
    setQuery(
      {
        title: "",
        body: "",
        uuid: "",
        email: "",
        nickname: "",
        os: "",
        app_name: "",
        notify_type: "",
        notify_action: "",
        push_status: "",
        open_status: "",
        user_type: "",
        save_option: "",
        start_date: formatDateStringToUTC(
          moment(new Date()).startOf("day").format("Y-MM-DD HH:mm:ss")
        ),
        end_date: formatDateStringToUTC(
          moment(new Date()).endOf("day").format("Y-MM-DD HH:mm:ss")
        ),
        sort_by: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setTitleSearch((_prev) => "");
    setContentSearch((_prev) => "");
    setUUIDSearch((_prev) => "");
    setEmailSearch((_prev) => "");
    setNicknameSearch((_prev) => "");
    setAppNameSearch("");
    setOSSearch((_prev: any) => null);
    setNotifyTypeSearch((_prev) => null);
    setDateSearch([null, null]);
    setIsGuestSearch("");
    setDataTypeSearch((_prev) => null);
    setPushStatusSearch((_prev) => null);
    setOpenStatusSearch((_prev) => null);
    setSaveOptionSearch("");
    setDateSearch([
      moment(`${moment().format("Y-MM-DD")}`, "Y-MM-DD").toDate(),
      moment(`${moment().format("Y-MM-DD")}`, "Y-MM-DD").toDate(),
    ]);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div>
              {pushLogs?.meta?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("App"),
        accessor: "app_name",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 150,
        Cell: (cell: any) => {
          let appName = cell?.row?.original?.user_device?.app_name;
          // if (cell?.row?.original?.user_type == 1) appName = "user";
          // else appName = "manager";
          let imgAppName = getOptionImage(appName);

          return (
            appName && (
              <div className="d-flex align-items-center whitespace-nowrap">
                {imgAppName ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgAppName ? (
                      <img
                        src={imgAppName}
                        width={20}
                        height={20}
                        alt="user_provider"
                      />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    APP_TYPE_OPTIONS?.find((i: any) => i?.value === appName)
                      ?.label || ""
                  )}
                </div>
              </div>
            )
          );
        },
      },
      {
        Header: t("Open Type"),
        accessor: "notify_action",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          const status = cell?.value;
          return cell?.value && (
            <div className="" style={{minWidth: 120}}>
              { t(NOTIFICATION_ACTION.find(
                  (i: any) => i?.value == status
                )?.label || '')
              }
            </div>
          );
        },
      },
      {
        Header: t("Send Type"),
        accessor: "notify_type",
        filterable: false,
        sortable: false,
        thWidth: 100,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;

          return (
            <div className="text-center" style={{ minWidth: "80px" }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_NOTIFY_TYPE[status] || "secondary"
                }`}
              >
                {
                  LIST_OPTION_NOTIFY_TYPE_LANG?.find(
                    (item: any) => item?.value === status
                  )?.label
                }
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Send Status"),
        accessor: "push_status",
        filterable: false,
        sortable: false,
        thWidth: 100,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;
          const detailError = cell?.row?.original?.detail_error;
          const msgError =
            i18n?.language === "en" ? detailError?.en : detailError?.ko;
          const minWidth: string | number =
            i18n?.language === "en" ? "125px" : "96px";

          return (
            <div className="position-relative" style={{ minWidth: minWidth }}>
              <div className="text-center" style={{ lineHeight: "16px" }}>
                <span
                  className={`rounded-pill badge bg-${
                    COLOR_PUSH_LOG_STATUS[status] || "secondary"
                  }`}
                >
                  {t(
                    LIST_OPTION_PUSH_STATUS_LANG?.find(
                      (item: any) => String(item?.value) === String(status)
                    )?.label ?? ""
                  )}
                </span>
              </div>
              {status === "failed" && msgError && (
                <TooltipCustom
                  title={t(msgError)}
                  className="d-inline-block vertical-align-middle ms-1 thumbnail-mt"
                  style={{
                    transform: "translateY(2px)",
                    position: "absolute",
                    top: -3,
                    right: 0,
                    paddingLeft: 4,
                    paddingRight: 3,
                  }}
                >
                  <i
                    className="ri-question-line align-bottom text-secondary"
                    style={{ fontSize: "16px" }}
                  ></i>
                </TooltipCustom>
              )}
            </div>
          );
        },
      },
      {
        Header: t("Log Open Status"),
        accessor: "open_status",
        filterable: false,
        sortable: false,
        thWidth: 100,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: "80px" }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_OPEN_STATUS[status] || "secondary"
                }`}
              >
                {
                  LIST_OPTION_OPEN_STATUS_LANG?.find(
                    (item: any) => item?.value === status
                  )?.label
                }
              </span>
            </div>
          );
        },
      },
      {
        Header: t("User Type"),
        accessor: "user_type",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_USER_TYPE_LOG[status] || "secondary"
                }`}
              >
                {t(
                  USER_TYPE_LOG_OPTION?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Save Notification"),
        accessor: "save_option",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_MANUAL_PUSH_SAVE_OPTION[status] || "secondary"
                }`}
              >
                {t(
                  MANUAL_PUSH_SAVE_OPTION?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Nickname"),
        accessor: "nickname",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 150,
        Cell: (cell: any) => {
          let nickname = cell?.row?.original?.user?.nickname;
          return (
            nickname && (
              <div className="cursor-pointer" style={{minWidth: 120}}>
                <CopyWrapper contentCopy={nickname}>
                  {`${nickname}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Email"),
        accessor: "email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          let email = cell?.row?.original?.user?.email;
          return (
            email && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={email}>{`${email}`}</CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("deviceOS"),
        accessor: "deviceOs",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          const deviceOS = cell?.row?.original?.user_device?.os;
          let imgOS = getPlatFormImage(deviceOS);

          return (
            deviceOS && (
              <div
                className="d-flex align-items-center"
                style={{ minWidth: "110px" }}
              >
                {imgOS ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgOS ? (
                      <img src={imgOS} width={20} height={20} alt="platform" />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    LIST_OPTION_OS?.find((item) => item?.value === deviceOS)
                      ?.label ?? ""
                  )}
                </div>
              </div>
            )
          );
        },
      },

      {
        Header: t("Device Id"),
        accessor: "device_id",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          let item = cell?.row?.original?.user_device?.device_id;
          return <div className="cursor-pointer" style={{ width: 140 }}>
            {item}
          </div>
        },
      },

      {
        Header: t("Device Model"),
        accessor: "device_model",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original?.user_device;
          let deviceModel = item?.device_model;
          const os = item?.os;
          if(os === 'ios') {
            deviceModel = deviceModel ? (IPHONE_MODELS[deviceModel as keyof typeof IPHONE_MODELS] ?? deviceModel)  : '';
          }

          return (
            deviceModel && (
              <div className="cursor-pointer" style={{ width: 150 }}>
                {t(`${deviceModel}`)}
              </div>
            )
          );
        },
      },

      {
        Header: t("Manufacturer"),
        accessor: "manufacturer",
        filterable: true,
        sortable: false,
        thWidth: 170,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const manufacturer = cell?.row?.original?.user_device?.manufacturer;
          return (
            manufacturer ? (
              <div className="cursor-pointer" style={{ minWidth: "160px" }}>
                <CopyWrapper contentCopy={manufacturer}>
                  {`${manufacturer}`}
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },

      {
        Header: t("UUID"),
        accessor: "udid",
        filterable: true,
        sortable: false,
        thWidth: 300,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original?.user_device;
          return (
            item?.udid_2 ? (
              <div className="cursor-pointer" style={{ minWidth: "290px" }}>
                <CopyWrapper contentCopy={item?.udid_2}>
                  {`${item?.udid_2}`}
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },
      {
        Header: t("FCM Token"),
        accessor: "token",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 340,
        Cell: (cell: any) => {
          const token = cell?.row?.original?.user_device?.device_token;

          return (
            token && (
              <div className="cursor-pointer" style={{ maxWidth: "330px" }}>
                <CopyWrapper contentCopy={token} style={{ minWidth: "70px", whiteSpace: "nowrap" }}>
                  {truncate(token, 36)}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Title"),
        accessor: "title",
        filterable: true,
        sortable: false,
        thWidth: 200,
        Cell: (cell: any) => {
          const title = cell?.value;

          return cell?.value && (
            <CopyWrapper contentCopy={cell?.value} style={{ minWidth: "200px"}}>
              <CollapseContent
                  style={{ maxWidth: "250px" }}
                  dataOriginal={cell?.value}
                  isRank={false}
                  isInlineBlock={true}
                  isShowModal={true}
                  titleModal={t("Title")}
                />
            </CopyWrapper>
          );
        },
      },
      {
        Header: t("Content"),
        accessor: "body",
        filterable: true,
        sortable: false,
        thWidth: 250,
        Cell: (cell: any) => {
          return cell?.value && (
            <CopyWrapper contentCopy={cell?.value} style={{minWidth: "220px"}}>
              <CollapseContent
                  style={{ maxWidth: "350px" }}
                  dataOriginal={cell?.value}
                  isRank={false}
                  isInlineBlock={true}
                  isShowModal={true}
                  titleModal={t("Content")}
                />
            </CopyWrapper>
          );
        },
      },

      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, userPermissions, pushLogs?.meta?.total]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  useEffect(() => {
    document.title = `${t("Push Log")} - ${t("Push Notification")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Push Log")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={pushLogs?.meta?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Title")}
                          isShow={false}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Title")}...`}
                            value={titleSearch}
                            onChange={(e) => setTitleSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Content")}
                          isShow={false}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Content")}...`}
                            value={contentSearch}
                            onChange={(e) => setContentSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Nickname")} isShow={false}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Nickname")}...`}
                            value={nicknameSearch}
                            onChange={(e) => setNicknameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Email")} isShow={false}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Email")}...`}
                            value={emailSearch}
                            onChange={(e) => setEmailSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("UUID")} isShow={false}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("UUID")}...`}
                            value={uuidSearch}
                            onChange={(e) => setUUIDSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("OS")} isShow={true}>
                          <DropdownOptionImage
                            name="os"
                            dataList={LIST_OPTION_OS || []}
                            placeholder={`${t("OS")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={oSSearch || ""}
                            onChangeSelect={(e: any) => setOSSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <div>
                          <LabelWrapper
                            label={t("Send Type")}
                            isShow={true}
                          >
                            <DropdownStatus
                              name="nofify-type"
                              dataList={LIST_OPTION_NOTIFY_TYPE_LANG || []}
                              placeholder={`${t("Send Type")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={notifyTypeSearch || null}
                              onChangeSelect={(e: any) =>
                                setNotifyTypeSearch(e)
                              }
                              isHasOptionAll={true}
                              optionAll={{ label: t("All Filter"), value: "" }}
                              colors={COLOR_NOTIFY_TYPE}
                            />
                          </LabelWrapper>
                        </div>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <div>
                          <LabelWrapper
                            label={t("Open Type")}
                            isShow={true}
                          >
                            <DropdownOption
                              name="notification_action"
                              dataList={
                                MANUAL_PUSH_REDIRECT_SCREEN_TARGET_LANG || []
                              }
                              placeholder={`${t("Open Type")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={dataTypeSearch || null}
                              onChangeSelect={(e: any) => setDataTypeSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t("All Filter"), value: "" }}
                            />
                          </LabelWrapper>
                        </div>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Send Status")} isShow={true}>
                          <DropdownStatus
                            name="push-status"
                            dataList={LIST_OPTION_PUSH_STATUS_LANG || []}
                            placeholder={`${t("Send Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={pushStatusSearch || null}
                            onChangeSelect={(e: any) => setPushStatusSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_PUSH_LOG_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Open Status")} isShow={true}>
                          <DropdownStatus
                            name="open-status"
                            dataList={LIST_OPTION_OPEN_STATUS_LANG || []}
                            placeholder={`${t("Open Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={openStatusSearch || null}
                            onChangeSelect={(e: any) => setOpenStatusSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_OPEN_STATUS}
                            isIntegerValue={true}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("User Type")} isShow={true}>
                          <DropdownStatusNew
                            name="type-user"
                            dataList={USER_TYPE_LOG_OPTION || []}
                            placeholder={`${t("User Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={isGuestSearch}
                            onChangeSelect={(e: any) =>
                              setIsGuestSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_USER_TYPE_LOG}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("App")} isShow={true}>
                          <DropdownOptionNew
                            name="app_name"
                            dataList={LIST_OPTION_SOURCE_APP || []}
                            placeholder={`${t("Select App Name")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={appNameSearch}
                            onChangeSelect={(e: any) =>
                              setAppNameSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            lstImage={true}
                            hideSelectedOptions={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Save Notification")} isShow={true}>
                          <DropdownStatusNew
                            name="open-status"
                            dataList={MANUAL_PUSH_SAVE_OPTION || []}
                            placeholder={`${t("Save Notification")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={saveOptionSearch}
                            onChangeSelect={(e: any) => setSaveOptionSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_MANUAL_PUSH_SAVE_OPTION}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!start_date || !!end_date}
                        >
                          <DatePickerCustom
                            startDate={start_date || null}
                            endDate={end_date || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        lg={6}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={pushLogs?.list?.length ? pushLogs?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={pushLogs?.meta?.total}
                      customPageCount={Math.ceil(
                        Number(pushLogs?.meta?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isPushLogLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PushLog;
